import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { takeWhile } from 'rxjs';
import { AppSide, AppStatesGridHeaderNames, PopupHeaderTexts } from 'src/app/constants';
import { StoreService } from 'src/app/features/store/services/store.service';

declare let bootstrap: any;

@Component({
  selector: 'app-check-revoke-state',
  templateUrl: './check-revoke-state.component.html',
  styleUrls: ['./check-revoke-state.component.scss']
})
export class CheckRevokeStateComponent implements OnInit, OnChanges, OnDestroy {

  @Input() fromComponent: string;

  @Input() sectionName: string;

  popupHeaderTexts = PopupHeaderTexts;

  @Input() revokeStatedata: any;

  myModal: any;

  appSide = AppSide;

  stateGridConfigData = {
    columns: [
      {
        headerName: AppStatesGridHeaderNames.partnerName,
        hide: false
      },
      {
        headerName: AppStatesGridHeaderNames.appName,
        hide: false
      },
      {
        headerName: AppStatesGridHeaderNames.state,
        hide: false
      },
      {
        headerName: AppStatesGridHeaderNames.domainName,
        hide: false
      }]
  }

  destroySubscription = false;

  constructor(private storeService: StoreService) {

  }

  ngOnInit(): void {

  }

  openModal() {
    this.myModal = new bootstrap.Modal(document.getElementById('revokeStateDataPopup'), {
      backdrop: 'static', keyboard: false
    });

    this.myModal.show();
  }

  closeRevokeStateDataPopup() {
    this.revokeStatedata.splice(0, this.revokeStatedata.length);
    this.myModal.hide();
  }

   createIdString() {
     if (this.fromComponent && this.sectionName) {
      return this.fromComponent + '-' + this.sectionName + '-revokeStatePopup'
    } else {
      return 'revokeStatePopup';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.revokeStatedata) {
      this.openModal();
    }
  }

  ngOnDestroy(): void {
    this.destroySubscription = true;
  }

}
